export enum DashboardMode {
  SUPER_USER = 'SUPER_USER',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  ASSET_MANAGER = 'ASSET_MANAGER',
  CONSTRUCTION_MANAGER = 'CONSTRUCTION_MANAGER',
  ADMINISTRATOR_LEVEL_ONE = 'ADMINISTRATOR_LEVEL_ONE',
  ADMINISTRATOR_LEVEL_TWO = 'ADMINISTRATOR_LEVEL_TWO',
}
